'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _ShopCard = require('./ShopCard');

var _ShopCard2 = _interopRequireDefault(_ShopCard);

var _reactBootstrap = require('react-bootstrap');

var _CollectionCard = require('../AccountManagement/CollectionCard');

var _CollectionCard2 = _interopRequireDefault(_CollectionCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Box = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Box, _Component);

  function Box() {
    (0, _classCallCheck3.default)(this, Box);
    return (0, _possibleConstructorReturn3.default)(this, (Box.__proto__ || (0, _getPrototypeOf2.default)(Box)).apply(this, arguments));
  }

  (0, _createClass3.default)(Box, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          shops = _props.shops,
          boxNumber = _props.boxNumber,
          type = _props.type;

      var styles = require('./Box.scss');
      var cards = [];
      if (type === 'collections') {
        for (var index = 0; index < boxNumber; index++) {
          cards.push(_react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-3', key: String(index) },
            _react2.default.createElement(_CollectionCard2.default, null)
          ));
        }
      } else if (shops && shops.length > 0) {
        var length = shops.length > boxNumber ? boxNumber : shops.length;
        for (var _index = 0; _index < length; _index++) {
          cards.push(_react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-3', key: String(_index) },
            _react2.default.createElement(_ShopCard2.default, { shop: shops[_index] })
          ));
        }
      } else {
        for (var _index2 = 0; _index2 < boxNumber; _index2++) {
          cards.push(_react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-3', key: String(_index2) },
            _react2.default.createElement(_ShopCard2.default, null)
          ));
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.box },
        _react2.default.createElement(
          'div',
          { className: styles.headerBox },
          _react2.default.createElement(
            'div',
            { className: styles.left },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              title
            ),
            _react2.default.createElement(
              'div',
              { className: styles.category },
              _react2.default.createElement('div', { className: styles.catSpa, title: 'Ch\u0103m S\xF3c Da/Massage' }),
              _react2.default.createElement('div', { className: styles.catHair, title: 'L\xE0m T\xF3c/M\xF3ng' }),
              _react2.default.createElement('div', { className: styles.catCosmetic, title: 'Th\u1EA9m M\u1EF9 Vi\u1EC7n' }),
              _react2.default.createElement('div', { className: styles.catClinic, title: 'Ph\xF2ng Kh\xE1m' }),
              _react2.default.createElement('div', { className: styles.catFitness, title: 'Th\u1EC3 D\u1EE5c Th\u1EC3 Thao' }),
              _react2.default.createElement('div', { className: styles.catTatoo, title: 'X\u0103m H\xECnh' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.right },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '#' },
              _react2.default.createElement(
                'div',
                { className: styles.seeMore },
                'Xem th\xEAm',
                _react2.default.createElement(_reactBootstrap.Glyphicon, (0, _defineProperty3.default)({
                  className: styles.arrowRight,
                  glyph: 'menu-right'
                }, 'className', styles.arrowRight))
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bodyBox + ' row' },
          cards
        )
      );
    }
  }]);
  return Box;
}(_react.Component), _class.propTypes = {
  title: _react.PropTypes.string.isRequired,
  shops: _react.PropTypes.array,
  type: _react.PropTypes.string,
  boxNumber: _react.PropTypes.number
}, _temp);
exports.default = Box;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/Box.js
// module id = 1509
// module chunks = 0